(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deal-money-counter-module"] && !Shopify.designMode) return;
  try {
    (() => {
    const initLanding = () => {
      const root = document;
      const stateRoot = document.documentElement;
      if (stateRoot.dataset.moneyCounterReady === 'true') return;
      stateRoot.dataset.moneyCounterReady = 'true';

      const dataNode = root.querySelector('[data-money-counter-models]');
      if (!dataNode) return;

      const data = JSON.parse(dataNode.textContent);
      const models = data.models;
      const labels = data.labels;
      const rows = [
        [labels.price, 'price'],
        [labels.speed, 'speed'],
        [labels.mixed, 'mixed'],
        [labels.currencies, 'currencies'],
        [labels.detection, 'detection'],
        [labels.pockets, 'pockets'],
        [labels.features, 'features'],
        [labels.bestFor, 'bestFor']
      ];
      const preferredDefaults = ['imc20', 'imc22', 'imc40', 'imc23'];
      const availableIds = models.map((model) => model.id);
      const defaultSlots = preferredDefaults.every((id) => availableIds.includes(id))
        ? preferredDefaults
        : availableIds.slice(0, 4);
      const requestedSlots = Array.from(new Set(new URLSearchParams(window.location.search).get('compare')?.split(',') || []))
        .filter((id) => availableIds.includes(id))
        .slice(0, 4);
      let compareSlots = requestedSlots.length === 4 ? requestedSlots : [...defaultSlots];
      const filterAliases = { all: 'all', bill: 'bill', basic: 'bill', mixed: 'mixed', professional: 'professional', 'two-pocket': 'professional', coin: 'coin' };
      const requestedFilter = new URLSearchParams(window.location.search).get('type');
      let activeFilter = filterAliases[requestedFilter] || 'all';

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
      }[character]));

      const pushEvent = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, landing_page: 'money_counter_deals', ...detail });
      };

      const syncUrl = () => {
        const url = new URL(window.location.href);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        if (isDefault) url.searchParams.delete('compare');
        else url.searchParams.set('compare', compareSlots.join(','));
        window.history.replaceState(null, '', url);
      };

      const optionsFor = (slot, activeSlots = compareSlots) => models.map((model) => {
        const isSelected = compareSlots[slot] === model.id;
        const isUsed = activeSlots.some((id, index) => index !== slot && id === model.id);
        return `<option value="${escapeHtml(model.id)}"${isSelected ? ' selected' : ''}${isUsed ? ' disabled' : ''}>${escapeHtml(model.model)}</option>`;
      }).join('');

      const imageFor = (model) => model.image
        ? `<img src="${escapeHtml(model.image)}" alt="${escapeHtml(model.title)}" width="160" height="120" loading="lazy">`
        : `<span aria-hidden="true">${escapeHtml(model.model)}</span>`;

      const namedColorHex = {
        black: '#111111',
        white: '#ffffff',
        gray: '#9ca3af',
        grey: '#9ca3af',
        silver: '#cbd5e1',
        blue: '#2563eb',
        red: '#dc2626',
        orange: '#f97316',
        green: '#16a34a',
        gold: '#d4a017'
      };

      const swatchesFor = (model) => {
        if (!Array.isArray(model.colors) || model.colors.length === 0) return '';
        const chips = model.colors.map((color) => {
          const hex = color.hex || namedColorHex[String(color.name || '').trim().toLowerCase()] || '';
          const dot = hex
            ? `<span class="money-counter-deals__color-dot" style="--mc-swatch: ${escapeHtml(hex)}" aria-hidden="true"></span>`
            : '';
          return `<span class="money-counter-deals__color-chip" title="${escapeHtml(color.name)}">${dot}<span>${escapeHtml(color.name)}</span></span>`;
        }).join('');
        return `<div class="money-counter-deals__color-swatches" aria-label="Available colors">${chips}</div>`;
      };

      const renderComparison = () => {
        const selected = compareSlots.map((id) => models.find((model) => model.id === id));
        const mobileSelected = selected.slice(0, 2);
        const mobileSlots = compareSlots.slice(0, 2);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        root.querySelector('[data-compare-status]').textContent = isDefault ? labels.defaultStatus : labels.customStatus;
        root.querySelector('[data-reset-compare]').hidden = isDefault;

        root.querySelector('[data-desktop-compare]').innerHTML = `
          <thead><tr><th scope="col">${escapeHtml(labels.feature)}</th>${selected.map((model, slot) => `
            <th scope="col">
              <label for="deal-desktop-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
              <div class="money-counter-deals__compare-head">
                <a class="money-counter-deals__compare-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
                <select id="deal-desktop-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot)}</select>
              </div>
              <div class="money-counter-deals__model-meta">
                <a class="money-counter-deals__model-link" href="${escapeHtml(model.url)}">${escapeHtml(model.model)}</a>
                ${swatchesFor(model)}
              </div>
            </th>`).join('')}</tr></thead>
          <tbody>${rows.map(([label, key]) => `<tr><th scope="row">${escapeHtml(label)}</th>${selected.map((model) => `<td>${escapeHtml(model[key])}</td>`).join('')}</tr>`).join('')}</tbody>`;

        root.querySelector('[data-mobile-compare-selectors]').innerHTML = `<div class="money-counter-deals__mobile-dimension-label"><span>Models</span><strong>Features</strong></div>` + mobileSelected.map((model, slot) => `
          <div class="money-counter-deals__mobile-selector">
            <a class="money-counter-deals__mobile-model-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
            <label for="deal-mobile-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
            <div class="money-counter-deals__mobile-selector-head">
              <select id="deal-mobile-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot, mobileSlots)}</select>
            </div>
          </div>`).join('');

        root.querySelector('[data-mobile-compare-results]').innerHTML = rows.map(([label, key]) => `
          <div class="money-counter-deals__mobile-compare-row" role="row">
            <div class="money-counter-deals__mobile-feature" role="rowheader">${escapeHtml(label)}</div>
            ${mobileSelected.map((model) => `<div class="money-counter-deals__mobile-value" role="cell">${escapeHtml(model[key])}</div>`).join('')}
          </div>`).join('');
      };

      const syncFilterUrl = () => {
        const url = new URL(window.location.href);
        if (activeFilter === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', activeFilter);
        window.history.replaceState(null, '', url);
      };

      const renderProductFilter = () => {
        const cards = Array.from(root.querySelectorAll('[data-money-counter-product-card]'));
        let visibleCount = 0;
        cards.forEach((card) => {
          const visible = activeFilter === 'all' || card.dataset.moneyCounterCategory === activeFilter;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === activeFilter));
        });
        root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterScene === activeFilter));
        });
        const status = root.querySelector('[data-money-counter-filter-status]');
        if (status) status.textContent = `${visibleCount} official models shown.`;
      };

      const initReviewCarousel = (attempts = 0) => {
        const slider = root.querySelector('[data-money-counter-review-carousel]');
        if (!slider) return;
        if (slider.splide) return;
        if (typeof window.Splide === 'undefined') {
          if (attempts < 100) window.setTimeout(() => initReviewCarousel(attempts + 1), 100);
          return;
        }

        const slideCount = slider.querySelectorAll('.splide__slide').length;
        if (!slideCount) return;
        const previous = root.querySelector('[data-review-prev]');
        const next = root.querySelector('[data-review-next]');
        const status = root.querySelector('[data-review-status]');
        const splide = new window.Splide(slider, {
          type: 'slide',
          rewind: true,
          perPage: 3,
          perMove: 3,
          gap: '16px',
          arrows: false,
          pagination: slideCount > 1,
          autoplay: false,
          drag: slideCount > 1,
          keyboard: 'focused',
          speed: 420,
          breakpoints: {
            990: { perPage: 2, perMove: 2 },
            700: { perPage: 1, perMove: 1 }
          },
          reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' }
        });

        const updateReviewStatus = () => {
          const visibleCount = Number(splide.options.perPage || 1);
          const movable = slideCount > visibleCount;
          if (previous) previous.hidden = !movable;
          if (next) next.hidden = !movable;
          if (status) status.textContent = `Review ${splide.index + 1} of ${slideCount}`;
        };
        if (previous) {
          previous.disabled = slideCount < 2;
          previous.addEventListener('click', () => splide.go('<'));
        }
        if (next) {
          next.disabled = slideCount < 2;
          next.addEventListener('click', () => splide.go('>'));
        }
        splide.on('mounted moved resized updated', updateReviewStatus);
        splide.mount();
        slider.splide = splide;
        updateReviewStatus();
      };

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-compare-slot]');
        if (!select) return;
        const slot = Number(select.dataset.compareSlot);
        const isMobile = Boolean(select.closest('[data-mobile-compare-selectors]'));
        const previousId = compareSlots[slot];
        const duplicateIndex = compareSlots.findIndex((id, index) => index !== slot && id === select.value);
        if (duplicateIndex !== -1) {
          if (isMobile && duplicateIndex >= 2) {
            compareSlots[duplicateIndex] = previousId;
          } else {
            renderComparison();
            return;
          }
        }
        compareSlots[slot] = select.value;
        syncUrl();
        renderComparison();
        pushEvent('change_compare_model', { product: select.value, compare_slot: slot + 1 });
      });

      root.querySelector('[data-reset-compare]').addEventListener('click', () => {
        compareSlots = [...defaultSlots];
        syncUrl();
        renderComparison();
        pushEvent('reset_compare_models');
      });

      root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterFilter;
          syncFilterUrl();
          renderProductFilter();
          pushEvent('filter_money_counter_models', { filter: activeFilter });
        });
      });

      root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterScene;
          syncFilterUrl();
          renderProductFilter();
          const catalog = root.querySelector('#money-counter-best-sellers');
          if (catalog) catalog.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-money-counter-event]');
        if (!trigger) return;
        const eventName = trigger.getAttribute('data-money-counter-event');
        if (eventName === 'add_to_cart') return;
        pushEvent(eventName, {
          product: trigger.getAttribute('data-money-counter-product') || undefined,
          use_case: trigger.getAttribute('data-money-counter-use-case') || undefined
        });
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-money-counter-event="add_to_cart"]');
        if (!form) return;
        pushEvent('add_to_cart', { product: form.getAttribute('data-money-counter-product') || undefined });
      });

      pushEvent('view_landing_page');
      renderComparison();
      renderProductFilter();
      initReviewCarousel();
      window.addEventListener('load', () => initReviewCarousel(), { once: true });
      const renderIcons = () => { if (window.lucide) window.lucide.createIcons(); };
      renderIcons();
      window.addEventListener('load', renderIcons, { once: true });
    };

    initLanding();
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', () => window.location.reload(), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deal-pda-module"] && !Shopify.designMode) return;
  try {
    (() => {
    const initLanding = () => {
      const root = document;
      const stateRoot = document.documentElement;
      if (stateRoot.dataset.moneyCounterReady === 'true') return;
      stateRoot.dataset.moneyCounterReady = 'true';

      const dataNode = root.querySelector('[data-money-counter-models]');
      if (!dataNode) return;

      const data = JSON.parse(dataNode.textContent);
      const models = data.models;
      const labels = data.labels;
      const rows = [
        [labels.price || 'Starting price', 'price'],
        [labels.scanRange || 'Scan distance', 'scanRange'],
        [labels.scanEngine || 'Scanner engine', 'scanEngine'],
        [labels.os || 'Operating system', 'os'],
        [labels.connectivity || 'Wireless & cellular', 'connectivity'],
        [labels.ruggedness || 'Ruggedness', 'ruggedness'],
        [labels.battery || 'Battery & charging', 'battery'],
        [labels.bestFor || 'Recommended use', 'bestFor']
      ];
      const preferredDefaults = ['mc005', 'ipda101', 'as01', 'ipda101p-lr'];
      const availableIds = models.map((model) => model.id);
      const defaultSlots = preferredDefaults.every((id) => availableIds.includes(id))
        ? preferredDefaults
        : availableIds.slice(0, 4);
      const requestedSlots = Array.from(new Set(new URLSearchParams(window.location.search).get('compare')?.split(',') || []))
        .filter((id) => availableIds.includes(id))
        .slice(0, 4);
      let compareSlots = requestedSlots.length === 4 ? requestedSlots : [...defaultSlots];
      const filterAliases = { all: 'all', standard: 'standard', 'long-range': 'long-range', keypad: 'keypad', rugged: 'keypad', touchscreen: 'touchscreen' };
      const requestedFilter = new URLSearchParams(window.location.search).get('type');
      let activeFilter = filterAliases[requestedFilter] || 'all';

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
      }[character]));

      const pushEvent = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, landing_page: 'pda_deals', ...detail });
      };

      const syncUrl = () => {
        const url = new URL(window.location.href);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        if (isDefault) url.searchParams.delete('compare');
        else url.searchParams.set('compare', compareSlots.join(','));
        window.history.replaceState(null, '', url);
      };

      const optionsFor = (slot, activeSlots = compareSlots, compact = false) => models.map((model) => {
        const isSelected = compareSlots[slot] === model.id;
        const isUsed = activeSlots.some((id, index) => index !== slot && id === model.id);
        const optionLabel = compact ? model.mobileModel : model.model;
        return `<option value="${escapeHtml(model.id)}"${isSelected ? ' selected' : ''}${isUsed ? ' disabled' : ''}>${escapeHtml(optionLabel)}</option>`;
      }).join('');

      const imageFor = (model) => model.image
        ? `<img src="${escapeHtml(model.image)}" alt="${escapeHtml(model.title)}" width="160" height="120" loading="lazy">`
        : `<span aria-hidden="true">${escapeHtml(model.model)}</span>`;

      const namedColorHex = {
        black: '#111111',
        white: '#ffffff',
        gray: '#9ca3af',
        grey: '#9ca3af',
        silver: '#cbd5e1',
        blue: '#2563eb',
        red: '#dc2626',
        orange: '#f97316',
        green: '#16a34a',
        gold: '#d4a017'
      };

      const swatchesFor = (model) => {
        if (!Array.isArray(model.colors) || model.colors.length === 0) return '';
        const chips = model.colors.map((color) => {
          const hex = color.hex || namedColorHex[String(color.name || '').trim().toLowerCase()] || '';
          const dot = hex
            ? `<span class="money-counter-deals__color-dot" style="--mc-swatch: ${escapeHtml(hex)}" aria-hidden="true"></span>`
            : '';
          return `<span class="money-counter-deals__color-chip" title="${escapeHtml(color.name)}">${dot}<span>${escapeHtml(color.name)}</span></span>`;
        }).join('');
        return `<div class="money-counter-deals__color-swatches" aria-label="Available colors">${chips}</div>`;
      };

      const renderComparison = () => {
        const selected = compareSlots.map((id) => models.find((model) => model.id === id));
        const mobileSelected = selected.slice(0, 2);
        const mobileSlots = compareSlots.slice(0, 2);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        root.querySelector('[data-compare-status]').textContent = isDefault ? labels.defaultStatus : labels.customStatus;
        root.querySelector('[data-reset-compare]').hidden = isDefault;

        root.querySelector('[data-desktop-compare]').innerHTML = `
          <thead><tr><th scope="col">${escapeHtml(labels.feature)}</th>${selected.map((model, slot) => `
            <th scope="col">
              <label for="deal-desktop-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
              <div class="money-counter-deals__compare-head">
                <a class="money-counter-deals__compare-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
                <select id="deal-desktop-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot)}</select>
              </div>
              <div class="money-counter-deals__model-meta">
                <a class="money-counter-deals__model-link" href="${escapeHtml(model.url)}">${escapeHtml(model.model)}</a>
                ${swatchesFor(model)}
              </div>
            </th>`).join('')}</tr></thead>
          <tbody>${rows.map(([label, key]) => `<tr><th scope="row">${escapeHtml(label)}</th>${selected.map((model) => `<td>${escapeHtml(model[key] || 'Not listed')}</td>`).join('')}</tr>`).join('')}</tbody>`;

        root.querySelector('[data-mobile-compare-selectors]').innerHTML = `<div class="money-counter-deals__mobile-dimension-label"><span>Models</span><strong>Features</strong></div>` + mobileSelected.map((model, slot) => `
          <div class="money-counter-deals__mobile-selector">
            <a class="money-counter-deals__mobile-model-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
            <label for="deal-mobile-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
            <div class="money-counter-deals__mobile-selector-head">
              <select id="deal-mobile-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot, mobileSlots, true)}</select>
            </div>
          </div>`).join('');

        root.querySelector('[data-mobile-compare-results]').innerHTML = rows.map(([label, key]) => `
          <div class="money-counter-deals__mobile-compare-row" role="row">
            <div class="money-counter-deals__mobile-feature" role="rowheader">${escapeHtml(label)}</div>
            ${mobileSelected.map((model) => `<div class="money-counter-deals__mobile-value" role="cell">${escapeHtml(model[key] || 'Not listed')}</div>`).join('')}
          </div>`).join('');
      };

      const syncFilterUrl = () => {
        const url = new URL(window.location.href);
        if (activeFilter === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', activeFilter);
        window.history.replaceState(null, '', url);
      };

      const renderProductFilter = () => {
        const cards = Array.from(root.querySelectorAll('[data-money-counter-product-card]'));
        let visibleCount = 0;
        cards.forEach((card) => {
          const categories = (card.dataset.moneyCounterCategory || '').split(/\s+/);
          const visible = activeFilter === 'all' || categories.includes(activeFilter);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === activeFilter));
        });
        root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterScene === activeFilter));
        });
        const status = root.querySelector('[data-money-counter-filter-status]');
        if (status) status.textContent = `${visibleCount} PDA families shown.`;
      };

      const initReviewCarousel = (attempts = 0) => {
        const slider = root.querySelector('[data-money-counter-review-carousel]');
        if (!slider) return;
        if (slider.splide) return;
        if (typeof window.Splide === 'undefined') {
          if (attempts < 100) window.setTimeout(() => initReviewCarousel(attempts + 1), 100);
          return;
        }

        const slideCount = slider.querySelectorAll('.splide__slide').length;
        if (!slideCount) return;
        const previous = root.querySelector('[data-review-prev]');
        const next = root.querySelector('[data-review-next]');
        const status = root.querySelector('[data-review-status]');
        const splide = new window.Splide(slider, {
          type: 'slide',
          rewind: true,
          perPage: 3,
          perMove: 3,
          gap: '16px',
          arrows: false,
          pagination: slideCount > 1,
          autoplay: false,
          drag: slideCount > 1,
          keyboard: 'focused',
          speed: 420,
          breakpoints: {
            990: { perPage: 2, perMove: 2 },
            700: { perPage: 1, perMove: 1 }
          },
          reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' }
        });

        const updateReviewStatus = () => {
          const visibleCount = Number(splide.options.perPage || 1);
          const movable = slideCount > visibleCount;
          if (previous) previous.hidden = !movable;
          if (next) next.hidden = !movable;
          if (status) status.textContent = `Review ${splide.index + 1} of ${slideCount}`;
        };
        if (previous) {
          previous.disabled = slideCount < 2;
          previous.addEventListener('click', () => splide.go('<'));
        }
        if (next) {
          next.disabled = slideCount < 2;
          next.addEventListener('click', () => splide.go('>'));
        }
        splide.on('mounted moved resized updated', updateReviewStatus);
        splide.mount();
        slider.splide = splide;
        updateReviewStatus();
      };

      root.addEventListener('change', (event) => {
        const variantSelect = event.target.closest('[data-product-variant-select]');
        if (variantSelect) {
          const card = variantSelect.closest('[data-money-counter-product-card]');
          const option = variantSelect.options[variantSelect.selectedIndex];
          const price = card?.querySelector('[data-card-price]');
          const comparePrice = card?.querySelector('[data-card-compare-price]');
          const discountBadge = card?.querySelector('[data-card-discount-badge]');
          const cardImage = card?.querySelector('[data-card-image]');
          const quantityInput = card?.querySelector('[data-quantity-input]');
          if (price && option?.dataset.price) price.textContent = option.dataset.price;
          if (comparePrice) {
            comparePrice.textContent = option?.dataset.comparePrice || '';
            comparePrice.hidden = !option?.dataset.comparePrice;
          }
          if (discountBadge) {
            discountBadge.textContent = option?.dataset.discountLabel || '';
            discountBadge.hidden = !option?.dataset.discountLabel;
          }
          if (cardImage && option?.dataset.imageSrc) {
            const nextImageSrc = option.dataset.imageSrc;
            const nextImageAlt = option.dataset.imageAlt || cardImage.alt;
            cardImage.dataset.pendingSrc = nextImageSrc;

            if (cardImage.src === new URL(nextImageSrc, window.location.href).href) {
              cardImage.alt = nextImageAlt;
            } else {
              const preloadedImage = new Image();
              preloadedImage.onload = () => {
                if (cardImage.dataset.pendingSrc !== nextImageSrc) return;
                cardImage.classList.add('is-changing');
                cardImage.src = nextImageSrc;
                cardImage.alt = nextImageAlt;
                window.requestAnimationFrame(() => {
                  window.requestAnimationFrame(() => cardImage.classList.remove('is-changing'));
                });
              };
              preloadedImage.src = nextImageSrc;
            }
          }
          if (quantityInput && option) {
            const minimum = Number(option.dataset.quantityMin || 1);
            const increment = Number(option.dataset.quantityStep || 1);
            quantityInput.min = String(minimum);
            quantityInput.step = String(increment);
            if (Number(quantityInput.value) < minimum) quantityInput.value = String(minimum);
          }
          pushEvent('change_product_configuration', {
            product: variantSelect.closest('form')?.getAttribute('data-money-counter-product') || undefined,
            variant_id: variantSelect.value
          });
          return;
        }

        const quantityInput = event.target.closest('[data-quantity-input]');
        if (quantityInput) {
          const minimum = Number(quantityInput.min || 1);
          const parsedValue = Number(quantityInput.value);
          if (!Number.isFinite(parsedValue) || parsedValue < minimum) quantityInput.value = String(minimum);
        }
      });

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-compare-slot]');
        if (!select) return;
        const slot = Number(select.dataset.compareSlot);
        const isMobile = Boolean(select.closest('[data-mobile-compare-selectors]'));
        const previousId = compareSlots[slot];
        const duplicateIndex = compareSlots.findIndex((id, index) => index !== slot && id === select.value);
        if (duplicateIndex !== -1) {
          if (isMobile && duplicateIndex >= 2) {
            compareSlots[duplicateIndex] = previousId;
          } else {
            renderComparison();
            return;
          }
        }
        compareSlots[slot] = select.value;
        syncUrl();
        renderComparison();
        pushEvent('change_compare_model', { product: select.value, compare_slot: slot + 1 });
      });

      root.querySelector('[data-reset-compare]').addEventListener('click', () => {
        compareSlots = [...defaultSlots];
        syncUrl();
        renderComparison();
        pushEvent('reset_compare_models');
      });

      root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterFilter;
          syncFilterUrl();
          renderProductFilter();
          pushEvent('filter_money_counter_models', { filter: activeFilter });
        });
      });

      root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterScene;
          syncFilterUrl();
          renderProductFilter();
          const catalog = root.querySelector('#money-counter-best-sellers');
          if (catalog) catalog.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });

      root.addEventListener('click', (event) => {
        const quantityButton = event.target.closest('[data-quantity-action]');
        if (quantityButton) {
          const control = quantityButton.closest('.money-counter-ads__quantity-control');
          const input = control?.querySelector('[data-quantity-input]');
          if (!input) return;
          if (quantityButton.dataset.quantityAction === 'plus') input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const trigger = event.target.closest('[data-money-counter-event]');
        if (!trigger) return;
        const eventName = trigger.getAttribute('data-money-counter-event');
        if (eventName === 'add_to_cart') return;
        pushEvent(eventName, {
          product: trigger.getAttribute('data-money-counter-product') || undefined,
          use_case: trigger.getAttribute('data-money-counter-use-case') || undefined
        });
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-money-counter-event="add_to_cart"]');
        if (!form) return;
        pushEvent('add_to_cart', {
          product: form.getAttribute('data-money-counter-product') || undefined,
          variant_id: form.querySelector('[name="id"]')?.value || undefined,
          quantity: Number(form.elements.quantity?.value || 1)
        });
      });

      pushEvent('view_landing_page');
      renderComparison();
      renderProductFilter();
      initReviewCarousel();
      window.addEventListener('load', () => initReviewCarousel(), { once: true });
      const renderIcons = () => { if (window.lucide) window.lucide.createIcons(); };
      renderIcons();
      window.addEventListener('load', renderIcons, { once: true });
    };

    initLanding();
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', () => window.location.reload(), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
